export default __webpack_public_path__ + "static/cookie-sandwich-b66a8dbf0db69629a7fb59cfcaedee88.jpg";